export default __webpack_public_path__ + "static/speedy8-8e1ddf1ba586a0c8b16079ba1cbf6056.svg";